import url from './url';

async function handleMyPayments(token) {

    let data = await fetch(`${url}/pagamento/list`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

async function handleMyPlans(token) {

    let data = await fetch(`${url}/pagamento/planos`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

async function handleOnlyPlans(token) {

    let data = await fetch(`${url}/pagamento/planosaluno`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

async function handleMyCourses(token) {

    try {
        let response = await fetch(`${url}/pagamento/list/cursos`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
            method: 'get'
        });

        if (response.status === 401) {
            throw new Error('Unauthorized'); 
        }

        let data = await response.json();
        return data;
    } catch (error) {
        throw error; 
    }

}

async function doPaymentBoleto(token, payload) {

    return await fetch(`${url}/pagamento/proccessboleto`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'post',
        body: JSON.stringify(payload)
    }).then(res => res.json());
    
}

async function doPaymentPix(token, payload) {

    return await fetch(`${url}/pagamento/proccesspix`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'post',
        body: JSON.stringify(payload)
    }).then(res => res.json());
    
}

/**
 * POST /api/pagamento/v5
 * Retorna HTTP status + body parseado com segurança (sucesso Pagar.me é JSON bruto, sem envelope).
 */
async function doPayment(token, payload) {
    const response = await fetch(`${url}/pagamento/v5`, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
        method: 'post',
        body: JSON.stringify(payload),
    });

    const rawText = await response.text();
    let data = null;
    let isJson = false;

    if (rawText && rawText.trim()) {
        try {
            data = JSON.parse(rawText);
            isJson = true;
        } catch (parseError) {
            isJson = false;
            data = null;
        }
    }

    return {
        httpStatus: response.status,
        ok: response.ok,
        data,
        rawText,
        isJson,
    };
}

async function validateCupom(token, payload) {

    return await fetch(`${url}/pagamento/cupom/validar`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'post',
        body: JSON.stringify(payload)
    }).then(res => res.json());
    
}

async function tokenCard(payload) {
    const options = {
        method: 'POST',
        headers: {accept: 'application/json', 'content-type': 'application/json'},
        body: JSON.stringify({
          card: {
            billing_address: {
              line_1: 'RUA DAS ALAMEDAS',
              line_2: 'SALA FUNDO',
              zip_code: '88103400',
              city: 'SAO JOSE',
              state: 'SC',
              country: 'BRASIL'
            },
            number: '4000000000000010',
            holder_name: 'FILIPE BICCA',
            holder_document: '04725073970',
            exp_month: 12,
            exp_year: 24,
            cvv: '333'
          }
        })
      };
      
      return fetch('https://api.pagar.me/core/v5/tokens', options)
        .then(response => response.json())
        .then(response => console.log(response))
        .catch(err => console.error(err));
}

export { handleMyPayments, handleMyCourses, validateCupom, doPayment, doPaymentBoleto, doPaymentPix, handleMyPlans, handleOnlyPlans }